import { CartItem } from '../types/cart'

export function cartItemPublicIdentity(
  item: Pick<CartItem, 'provider' | 'rateGroup'>
): { code: string; name: string } {
  if (item.rateGroup) {
    return { code: item.rateGroup.rateGroupCode, name: item.rateGroup.name }
  }
  if (item.provider) {
    return { code: item.provider.code, name: item.provider.name }
  }
  return { code: '', name: '' }
}
